import { dexieLotRepo } from '../offline/repos/DexieLotRepo'
import { dexieFarmRepo } from '../offline/repos/DexieFarmRepo'
import { mortalityLogApi } from './mortalityLogApi'
import { refreshProductionUnitTableFromApi } from './productionUnitTable'
import { refreshWaterTableRowsFromApi } from './waterTable'

// Findings #157 (rehearsal 3, 2026-10-12): Lote → Incubación / Proyección
// are built from this browser's cache (mortality records, Base de datos rows,
// water readings). Crew records from a phone only reached that cache once
// Biomasa or Agua had been opened, so the office saw old numbers after
// "Actualizar lotes" or a reload. Before those tabs recalculate, pull the
// lot's facility mortality records and, for the lot's unit and the other
// units of the same arrival (temperatures can come from them, #150), the
// Base de datos rows and water readings. Offline or on an error the cache is
// used as before. Resolves true when at least one pull reached the server.
export const refreshLotSourcesFromServer = async (lotId: string): Promise<boolean> => {
  const lot = await dexieLotRepo.getById(lotId)
  if (!lot?.farmId) return false
  const farmId = lot.farmId
  const rootId = lot.lineageRootId || lot.id
  const [lots, farm] = await Promise.all([
    dexieLotRepo.list().catch(() => []),
    dexieFarmRepo.getById(farmId).catch(() => undefined)
  ])
  const unitIds = new Set<string>()
  if (lot.productionUnitId) unitIds.add(String(lot.productionUnitId))
  lots.forEach((candidate) => {
    if (
      candidate.farmId === farmId
      && (candidate.lineageRootId || candidate.id) === rootId
      && (!candidate.stage || candidate.stage === 'Active')
      && candidate.productionUnitId
    ) unitIds.add(String(candidate.productionUnitId))
  })
  const farmName = typeof farm?.name === 'string' ? farm.name : undefined
  const units = (farm as { productionUnits?: Array<{ id: string; name?: string }> } | undefined)?.productionUnits ?? []
  const pulls: Array<Promise<unknown>> = [mortalityLogApi.list({ farmId }, { forceRemote: true })]
  unitIds.forEach((productionUnitId) => {
    const context = {
      farmId,
      productionUnitId,
      farmName,
      productionUnitName: units.find((unit) => unit.id === productionUnitId)?.name || productionUnitId
    }
    pulls.push(refreshProductionUnitTableFromApi(context, { forceRemote: true }))
    pulls.push(refreshWaterTableRowsFromApi(context))
  })
  const results = await Promise.allSettled(pulls)
  return results.some((result) => result.status === 'fulfilled')
}
